// Icons exported from the Figma frame "Settings / Mobile – Popup" (5054:78824) on the PAVEL DRAFT
// page, section "Settings", via the Dev Mode asset server. The root width/height were dropped so
// svgr keeps the viewBox and the icons scale with the modal (see the web build's svgo defaults).
import ChevronSvg from './chevron.svg';
import ChevronDownSvg from './chevron-down.svg';
import IconGameRulesSvg from './icon-game-rules.svg';
import IconHandPowerMeterSvg from './icon-hand-power-meter.svg';
import IconHelpSvg from './icon-help.svg';
import IconInviteFriendsSvg from './icon-invite-friends.svg';
import IconLanguageSvg from './icon-language.svg';
import IconLogOutSvg from './icon-log-out.svg';
import IconNotificationsSvg from './icon-notifications.svg';
import IconPersonalDataSvg from './icon-personal-data.svg';
import IconSoundsSvg from './icon-sounds.svg';
import IconStartTutorialSvg from './icon-start-tutorial.svg';

export {
	ChevronDownSvg,
	ChevronSvg,
	IconGameRulesSvg,
	IconHandPowerMeterSvg,
	IconHelpSvg,
	IconInviteFriendsSvg,
	IconLanguageSvg,
	IconLogOutSvg,
	IconNotificationsSvg,
	IconPersonalDataSvg,
	IconSoundsSvg,
	IconStartTutorialSvg,
};
